"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundDestination = void 0;
var tslib_1 = require("tslib");
var open_xml_color_import_helper_1 = require("../../color/open-xml-color-import-helper");
var destination_1 = require("../destination");
var BackgroundDestination = (function (_super) {
    tslib_1.__extends(BackgroundDestination, _super);
    function BackgroundDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackgroundDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.documentModel.setPageColor(this.documentModel.cache.colorModelInfoCache.getItem(open_xml_color_import_helper_1.OpenXmlColorImportHelper.createColorModelInfo(this.data, reader, 'color')).
                    toRgb(this.data.documentModel.colorProvider));
                return [2];
            });
        });
    };
    return BackgroundDestination;
}(destination_1.LeafElementDestination));
exports.BackgroundDestination = BackgroundDestination;
